module.exports = __webpack_public_path__ + "assets/1albya.128c4524.svg";